import React from "react";
import { AlertTriangle } from "lucide-react";

// Türkçe'ye özgü harfler. Aynı harf farklı cihazlarda farklı Unicode
// biçiminde (NFC/NFD) kodlanabildiği için şifrede kullanılması riskli:
// kullanıcı doğru şifreyi yazsa bile giriş reddedilebilir veya şifreli
// yedeği açılamaz. Bu yüzden ENGELLEMİYORUZ, sadece UYARIYORUZ.
const TR_CHARS = /[ıİşŞğĞçÇöÖüÜâÂîÎûÛ]/;

export const hasTurkishChars = (value) => TR_CHARS.test(String(value || ""));

export const TurkishPasswordWarning = ({ value, testId = "tr-password-warning" }) => {
  if (!hasTurkishChars(value)) return null;
  return (
    <div
      data-testid={testId}
      className="mb-2 rounded border border-amber-400/50 bg-amber-500/10 px-2 py-1.5 text-[11px] leading-relaxed text-amber-200"
    >
      <AlertTriangle className="mr-1 -mt-0.5 inline h-3.5 w-3.5" />
      Şifrenizde <b>Türkçe karakter (ı İ ş ğ ç ö ü)</b> kullanmamanız önerilir. Aynı harf
      telefon ve bilgisayarda farklı şekilde kodlanabildiği için şifrenizi doğru yazsanız
      bile <b>giriş yapamama</b> veya <b>yedeğinizi açamama</b> durumu oluşabilir.
      Şifre kabul edilir, karar sizin.
    </div>
  );
};

export default TurkishPasswordWarning;
